module.exports = __webpack_public_path__ + "img/view-carousel-outline-blk.ce785746.svg";